import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'src/components/atoms/Button'
// import Pill from "src/components/atoms/Pill";
import LocationCard from 'src/components/cards/LocationCard'
import Page from 'src/components/layouts/Page'
import Dropdown from 'src/components/molecules/Dropdown'
import InputWrap from 'src/components/molecules/InputWrap'
import css from './Profile.module.scss'
import { useNavigate } from 'react-router-dom'

import NameAvatar from 'src/components/molecules/NameAvatar'
import Input from 'src/components/atoms/Input'
import { toast } from 'react-toastify'
import GlobalModal from 'src/components/modals/GlobalModal'

import NumberFormat from 'react-number-format'
import Keypad from 'src/components/organisms/Keypad'
import { Modal } from '@mantine/core'
import PinModal from 'src/components/modals/PinModal'
import {
	addLocation,
	clearState,
	getBusinessInfoSignup,
	setStep,
	setToken,
} from 'src/slices/signup'
import {
	editPersonalDetails,
	forgotPassword,
	setLocked,
	clearState as clearAuth,
} from 'src/slices/auth'
import { handleStatus } from 'src/slices/utils'
import IconCard from 'src/components/cards/IconCard'

export default function Profile(params) {
	const { user, token, refreshToken, status: authStatus } = useSelector(state => state.auth)

	const { user: signupUser, status } = useSelector(state => state.signup)

	const { locations } = useSelector(state => state.info)

	const navigate = useNavigate()
	const dispatch = useDispatch()

	useEffect(() => {
		handleStatus(status.addLocation, () => dispatch(clearState(status.addLocation)), {
			isSuccess: {
				callback: () => {
					dispatch(setToken({ token, refreshToken, data: signupUser.id }))
					dispatch(getBusinessInfoSignup())
				},
			},
		})
	}, [status])
	useEffect(() => {
		handleStatus(authStatus.forgotPassword, () => dispatch(clearAuth()))
	}, [authStatus.forgotPassword])

	const handleNewLocation = () => {
		dispatch(addLocation())
		// dispatch(addLoc()).then((res) => {
		//     const message = localStorage.getItem("message");
		//     if (message === "New Location added successfully.") {
		//         dispatch(setstep(1));
		//         Navigate("/signup");
		//     }
		// });
	}

	const [typedPin, setTypedPin] = useState()

	const [changePin, setChangePin] = useState({
		isOpen: false,
		active: 'confirm',
		confirm: { title: 'Enter your current pin' },
		edit: { title: 'Enter your new pin' },
	})

	const [changeInInfo, setChangeInInfo] = useState(false)
	const handleNumChange = event => {
		// TODO: Change to green button on side of input
		if (event.key === 'Enter') {
			if (
				!event.target.value.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm)
			) {
				toast.warning('Phone number must be a valid U.S. phone number')
			} else if (event.target.value == user.phone) {
				toast.warning('Phone number must be different in order to change it')
			} else {
				// TODO: Global url variable so that this works on prod and dev
				// TODO: Format phone number to +1 ###-#### format
				dispatch(
					editPersonalDetails({
						email: user.email,
						phone: event.target.value,
					})
				)

				toast.success('Phone Number Updated')
			}
		}
	}

	const handlePinChange = event => {
		if (changePin.active == 'confirm') {
			if (event.key === 'Enter') {
				if (!event.target.value.match(/^[0-9]{6}$/g)) {
					toast.warning('New pin must be 6 digits long')
				} else if (event.target.value != user.pin) {
					toast.error('Wrong pin')
				} else {
					// // TODO: Global url variable so that this works on prod and dev
					// // TODO: Format phone number to +1 ###-#### format
					// dispatch(editPersonalDetails({ email: Person?.data?.email.value, pin: event.target.value }))
					// dispatch(getPer());

					setChangePin({ ...changePin, active: 'edit' })
					setTypedPin('')

					toast.success('Pin confirmed')
				}
			}
		}

		if (changePin.active == 'edit') {
			if (event.key === 'Enter') {
				if (!event.target.value.match(/^[0-9]{6}$/g)) {
					toast.warning('New pin must be 6 digits long')
				} else if (event.target.value == user.pin) {
					toast.warning('New pin must be different in order to change it')
				} else {
					// TODO: Global url variable so that this works on prod and dev
					// TODO: Format phone number to +1 ###-#### format
					dispatch(
						editPersonalDetails({
							email: user.email,
							passcode: event.target.value,
						})
					)

					toast.success('Pin Updated')

					setChangePin({
						...changePin,
						isOpen: false,
						active: 'confirm',
					})
				}
			}
		}
	}

	return (
		<Page>
			{/* <h2>Hello Somebody! 👋</h2> */}
			<div className={css['layout']}>
				<div className={css['section'] + ' ' + css['section--profile']}>
					<NameAvatar
						name={`${user.firstName} ${user.lastName}`}
						firstName={user.firstName}
						lastName={user.lastName}
						// src="images/user.jpeg"
						size='96px'
						// showEdit   // just turn this on when the functionality is available
					/>

					<div className={css['inputs']}>
						<InputWrap
							component={
								<input
									type='email'
									value={user.email}
									readOnly
								/>
							}
							label='Personal Email'
						/>

						<InputWrap
							component={
								<NumberFormat
									allowEmptyFormatting
									mask='_'
									type='tel'
									format='+1 (###) ###-####'
									// {...sharedProps}
									onKeyPress={handleNumChange}
									defaultValue={user.phone}
								/>
							}
							label='Personal Phone'
						/>

						{changeInInfo && (
							<Button
								label='Save Changes'
								color='emerald'
							/>
						)}
					</div>
				</div>

				<div className={css['section']}>
					<header className={css['header']}>
						<h3>My Locations</h3>
						<Button
							label='Add Location'
							iconLeft='fad fa-plus'
							action={handleNewLocation}
							color='gray'
							variant='secondary'
						/>
					</header>

					<div className={css['locations']}>
						{locations.map(location => {
							return (
								<LocationCard
									location={location}
									key={location.businessName}
								/>
							)
						})}
						{/* <IconCard
							iconName='plus'
							label='Add Location'
							type='add'
							clickable
							style={{ minHeight: '100px', minWidth: '280px' }}
							action={handleNewLocation}
						/> */}
					</div>
				</div>

				<div className={css['section']}>
					<header className={css['header']}>
						<h3>Account Security</h3>
						{/* <Dropdown iconName="question-circle" cursor="help">
                            <p className={css["message"]}>
                                You need to contact the support to change your
                                password.
                            </p>
                        </Dropdown> */}
						{/* <Button label="Add Location" iconLeft="fad fa-plus" /> */}
					</header>
					<div className={css['section-buttons']}>
						{/* <Button label="Change Password" color="white" iconLeft="fad fa-key" /> */}
						<Button
							label='Change PIN'
							color='gray'
							iconLeft='fas fa-th-large'
							variant='secondary'
							action={() => setChangePin({ ...changePin, isOpen: true })}
						/>
						<Button
							label='Change Password'
							color='gray'
							iconLeft='fad fa-key'
							variant='secondary'
							action={() => dispatch(forgotPassword(user))}
						/>
					</div>
				</div>

				<div className={css['buttons']}>
					<Button
						label='Lock'
						color='gray'
						variant='secondary'
						iconLeft='fad fa-lock-alt'
						// href='/pin'
						action={() => {
							dispatch(setLocked())
							navigate('/pin')
						}}
					/>
					{/* <Button
						label='Log Out'
						color='error'
						variant='tertiary'
						iconLeft='fad fa-sign-out'
					/> */}
				</div>
			</div>
			{changePin.isOpen && (
				<PinModal
					closeFunction={() => {
						setChangePin({ ...changePin, isOpen: false })
						setTypedPin('')
					}}
				/>
			)}

			{/* {changePin.isOpen && (
                <GlobalModal
                    title={changePin[changePin.active].title}
                    closeFunction={() => {
                        setChangePin({ ...changePin, isOpen: false });
                        setTypedPin("");
                    }}

                    // buttons={
                    //     <>
                    //         <Button
                    //             label="Submit"
                    //             color="emerald"
                    //             action ={handlePinChange({event: {key: "Enter", target: {value : typedPin}}})}
                    //         />
                    //     </>
                    // }
                >
                    <div style={{ display: "inline-flex" }}>
                        {user.pin && (
                            <Input
                                label={changePin.label}
                                htmlType="number"
                                value={typedPin}
                                onChange={(event) =>
                                    setTypedPin(event.target.value)
                                }
                                onKeyPress={handlePinChange}

                                // readOnly
                            />
                        )}
                    </div>
                </GlobalModal>
            )} */}
		</Page>
	)
}
